var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"auto"}},[_c('div',{staticStyle:{"color":"white","font-size":"12px"}},[_vm._v(_vm._s(_vm.objvalue.Desc))]),_c('img',{staticStyle:{"width":"100%","height":"auto","max-height":"100%"},attrs:{"src":_vm.objvalue.Data.PicUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }